import { fr } from 'date-fns/locale';
import { forwardRef, useImperativeHandle, useRef } from 'react';

import { DatePicker } from '../DatePicker';
import { DatePickerActions } from '../DatePicker/DatePicker.types';

import { DateRangePickerProps } from './DateRangePicker.types';

export const DateRangePicker = forwardRef<DatePickerActions, DateRangePickerProps>(
  ({ locale = fr, selected, monthsShown = 2, ...props }, ref) => {
    const innerRef = useRef<DatePickerActions>(null);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    useImperativeHandle(ref, () => innerRef.current!, []);

    return (
      <DatePicker
        locale={locale}
        selected={selected?.[0]}
        startDate={selected?.[0]}
        endDate={selected?.[1]}
        selectsRange
        monthsShown={monthsShown}
        {...props}
        ref={ref}
      />
    );
  }
);
